import { gql } from 'apollo-angular'

export const GET_USER_COUNT_BY_ORGANIZATION = gql`
  query getUsers($organizationId: JSON!) {
    Users(where: { organization: { equals: $organizationId } }) {
      totalDocs
    }
  }
`
